module.exports = __webpack_public_path__ + "img/joinmeeting.3846fbf9.svg";